<template>
    <div>
        <!-- 列表筛选 -->
        <div v-if="type == 2" class="c-taskpage-taskList">
            <!-- <XScroll style="width: 100%; height: 100%"> -->
            <div class="task-status" style="width: 98%">
                <p class="task-status-first">{{ $t('taskPage.taskList.taskStatus') }}</p>
                <el-radio-group
                    class="status-checkbox"
                    @change="handleClick"
                    ref="radio"
                    v-model="activeName"
                >
                    <el-radio :label="99"
                        >{{ $t('taskPage.taskList.allStatus') }}{{ ` &nbsp;${getCountByStatus('0')}` }}
                    </el-radio>
                    <el-radio :label="1">
                        {{ $t('taskPage.taskList.pendingExecution') }} &nbsp;{{
                            `
            &nbsp;${getCountByStatus('1')}`
                        }}</el-radio
                    >
                    <el-radio :label="2">
                        {{ $t('taskPage.taskList.executing') }} &nbsp;{{
                            ` &nbsp;${getCountByStatus('2')}`
                        }}</el-radio
                    >
                    <el-radio :label="3">
                        {{ $t('taskPage.taskList.pendingUploadData')
                        }}{{ ` &nbsp;${getCountByStatus('3')}` }}</el-radio
                    >
                    <el-radio :label="5">
                        {{ $t('taskPage.taskList.completed')
                        }}{{ ` &nbsp;${getCountByStatus('5')}` }}</el-radio
                    >
                    <el-radio :label="6">
                        {{ $t('taskPage.taskList.terminated')
                        }}{{ ` &nbsp;${getCountByStatus('6')}` }}</el-radio
                    >
                </el-radio-group>
            </div>
            <div class="task-find">
                <div class="task-name">
                    <p class="task-name-first">{{ $t('taskPage.taskList.taskName') }}</p>
                    <el-input
                        v-model="selectObj.name"
                        clearable
                        size="small"
                        :placeholder="$t('taskPage.taskList.inputTaskName')"
                    ></el-input>
                </div>
                <!-- <div class="task-name">
                      <p class="task-name-first">任务编号</p>
                      <el-input v-model="taskNumber" size="small" placeholder="输入任务编号"></el-input>
                  </div> -->
                <div class="task-name">
                    <p class="task-name-first">{{ $t('taskPage.taskList.applyDept') }}</p>
                    <select-tree
                        :value="selectObj.deptId"
                        :list="deptList"
                        :treeprops="deptProps"
                        :placeholder="$t('taskPage.taskList.selectApplyDept')"
                        :checkStrictly="true"
                        @change="deptChange"
                    />
                </div>
                <div class="task-name">
                    <p class="task-name-first">{{ $t('taskPage.taskList.serviceItem') }}</p>
                    <select-tree
                        :value="selectObj.dataSubjectId"
                        :list="dataSubjectOptions"
                        :treeprops="dataSubjectProps"
                        :placeholder="$t('taskPage.taskList.selectServiceItem')"
                        :checkStrictly="true"
                        @change="subjectChange"
                    />
                </div>
                <div class="task-name">
                    <p class="task-name-first">{{ $t('taskPage.taskList.executionMethod') }}</p>
                    <el-select
                        v-model="selectObj.model"
                        style="max-width: 8.4vw"
                        @blur="taskTypeChange"
                        :placeholder="$t('taskPage.taskList.selectExecutionMethod')"
                        clearable
                        collapse-tags
                        popper-class="selectTree"
                    >
                        <el-option
                            v-for="dict in modelData"
                            :key="dict.dictValue"
                            :label="dict.dictLabel"
                            :value="dict.dictValue"
                        />
                    </el-select>
                </div>
                <div class="task-name-date">
                    <p class="task-name-first">{{ $t('taskPage.taskList.planExecutionTime') }}</p>
                    <el-date-picker
                        v-model="planDate"
                        type="daterange"
                        :clearable="true"
                        @change="planchange"
                        size="small"
                        :format="'yyyy-MM-dd'"
                        :value-format="'yyyy-MM-dd'"
                        range-separator="⇀"
                        :start-placeholder="$t('taskPage.taskList.startDate')"
                        :end-placeholder="$t('taskPage.taskList.endDate')"
                        popper-class="mydata"
                        :unlink-panels="true"
                    ></el-date-picker>
                    <i class="el-icon-date not-time" v-if="!planDate || planDate.length === 0"></i>
                </div>
                <div class="task-name-date">
                    <p class="task-name-first">{{ $t('taskPage.taskList.actualExecutionTime') }}</p>
                    <el-date-picker
                        v-model="selectDate"
                        type="daterange"
                        :clearable="true"
                        @change="daychange"
                        size="small"
                        :format="'yyyy-MM-dd'"
                        :value-format="'yyyy-MM-dd'"
                        range-separator="⇀"
                        :start-placeholder="$t('taskPage.taskList.startDate')"
                        :end-placeholder="$t('taskPage.taskList.endDate')"
                        popper-class="mydata"
                        :unlink-panels="true"
                    ></el-date-picker>
                    <i class="el-icon-date not-time" v-if="!selectDate || selectDate.length === 0"></i>
                </div>
                <div
                    @click="resetTask"
                    style="cursor: pointer"
                    :class="{ 'task-refresh-list': type == 2, 'task-refresh-other': type == 3 }"
                >
                    <i class="el-icon-refresh-right"></i> {{ $t('taskPage.taskList.reset') }}
                </div>
                <div
                    @click="screenTask"
                    style="cursor: pointer"
                    :class="{ 'task-search-list': type == 2, 'task-search-other': type == 3 }"
                >
                    <i class="el-icon-search"></i> {{ $t('taskPage.taskList.query') }}
                    <!-- <p class="tab-title">查询</p> -->
                </div>
            </div>
            <!-- </XScroll> -->
        </div>

        <div v-if="type == 2" class="newTask">
            <div class="addNewTask-line">
                <div class="addTask-top">
                    <div class="addNewTask" @click="addNewTask(1)">
                        <i class="el-icon-plus"></i> {{ $t('taskPage.taskList.addTask') }}
                    </div>
                    <div
                        class="newTask-ul"
                        :class="{ isSetting: isSetting2 === true }"
                        @click.stop="showBg(2)"
                    >
                        <el-tooltip
                            effect="dark"
                            :content="$t('taskPage.taskList.fieldDisplay')"
                            popper-class="icon-tooltip"
                            placement="top"
                        >
                            <img src="../imgs/settings-4-line.png" />
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div class="TaskTable2">
                <TaskTable2
                    @detail="showForm($event)"
                    @SavePage="SavePage()"
                    @delete="addATask('delete')"
                    @taskHandle="taskHandle($event)"
                    :modelData="modelData"
                    :page="pageArray"
                    :tableData="taskPageList"
                    :isShowFeild="showField"
                />
            </div>
            <div class="pagepagetion">
                <Pagination
                    :total.sync="pageArray.totalResult"
                    :pageNum.sync="pageArray.currentPage"
                    :limit.sync="pageArray.pageSize"
                    :reset="pageArray.reset"
                    @pagination="fetchData($event)"
                />
            </div>
        </div>
        <div v-show="type == 3" class="taskmain">
            <TaskCalendar
                @add="addNewTask(1, $event)"
                @refresh="saveAddTask"
                @SaveCalendPage="SaveCalendPage($event)"
                @taskHandle="taskHandle($event)"
                :saveTime="saveTime"
                @detail="showForm($event)"
            />
        </div>
        <div v-if="showTaskDialog">
            <TaskAdd :taskTitle="addTaskType" @add="addATask" @save="saveAddTask($event)" :taskId="taskId" :taskDate="taskAddTime" />
        </div>
        <div class="tasklist" v-if="dialogVisible">
            <el-dialog
                custom-class="addTask"
                :title="dialogTitle"
                :close-on-click-modal="false"
                :visible="dialogVisible"
                :show-close="false"
            >
                <el-form ref="taskFormRef" :model="taskform" :rules="rules" label-width="80px">
                    <el-row :gutter="30" v-if="dialogtaskType === 'confirmTask'">
                        <el-col :span="24" style="color: #fff">
                            {{ $t('taskPage.taskList.confirmExecution') }}
                        </el-col>
                        <el-col :span="24" style="margin-top: 14px"
                            ><el-form-item
                                :label="$t('taskPage.taskList.confirmPassword')"
                                prop="checkPassword"
                            >
                                <el-input
                                    v-model="taskform.checkPassword"
                                    :placeholder="$t('taskPage.taskList.inputConfirmPassword')"
                                /> </el-form-item
                        ></el-col>
                    </el-row>
                    <el-row :gutter="30" v-if="dialogtaskType === 'compeleteTask'">
                        <el-col :span="24" style="color: #fff">
                            {{ $t('taskPage.taskList.confirmEndTask') }}</el-col
                        >
                        <!-- <el-col :span="24" style="margin-top: 14px"
                ><el-form-item label="确认密码" prop="checkPassword">
                  <el-input
                    v-model="taskform.checkPassword"
                    placeholder="请输入确认密码	"
                  /> </el-form-item
              ></el-col> -->
                    </el-row>
                    <el-row :gutter="30" v-if="dialogtaskType === 'overTask'">
                        <el-col :span="24" style="color: #fff">
                            {{ $t('taskPage.taskList.confirmTaskSuccess') }}</el-col
                        >
                    </el-row>
                    <el-row :gutter="30" v-if="dialogtaskType === 'endTask'">
                        <el-col :span="24" style="color: #fff">
                            {{ $t('taskPage.taskList.confirmTerminateTask') }}</el-col
                        >
                        <!-- <el-col :span="24" style="margin-top: 14px"
                ><el-form-item label="确认密码" prop="checkPassword">
                  <el-input
                    v-model="taskform.checkPassword"
                    placeholder="请输入确认密码	"
                  /> </el-form-item
              ></el-col> -->
                        <el-col :span="24" style="margin-top: 14px"
                            ><el-form-item :label="$t('taskPage.taskList.terminateReason')" prop="stopReason">
                                <el-input
                                    v-model="taskform.stopReason"
                                    :placeholder="$t('taskPage.taskList.inputTerminateReason')"
                                    type="textarea"
                                /> </el-form-item
                        ></el-col>
                    </el-row>
                    <el-col :span="24">
                        <div
                            class="dialog__footer"
                            style="margin: 5px 0; clear: both; overflow: hidden; text-align: center"
                        >
                            <el-button class="cancel" @click="taskClose">{{
                                $t('taskPage.taskList.cancel')
                            }}</el-button>
                            <el-button plain class="save" @click="passTask">{{
                                $t('taskPage.taskList.confirm')
                            }}</el-button>
                        </div>
                    </el-col>
                </el-form>

                <img
                    class="fix-close"
                    v-if="dialogVisible"
                    src="../imgs/icon_关闭.png"
                    alt="$t('taskPage.taskList.close')"
                    @click="taskClose"
                />
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { XScroll } from '@CommonComponent';

import api from '../api';
import { handleTree, addDateRange } from '@/utils/common.js';

import TaskTable2 from '../common/TaskTable2.vue';
import TaskCalendar from './TaskCalendar.vue';
import Pagination from '../common/Pagination.vue';
import TaskAdd from '../common/taskAdd.vue';

export default {
    components: {
        TaskTable2,
        Pagination,
        TaskCalendar,
        TaskAdd,
        // YScroll,
        // XScroll,
    },
    props: {
        type: {
            type: Number,
            default: 2,
        },
        modelData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            dialogtaskType: '',
            taskform: {
                checkPassword: '',
                id: '',
                executeTime: '',
                remark: '',
            },
            rules: {
                checkPassword: [
                    {
                        required: true,
                        message: this.$t('taskPage.taskList.confirmPasswordEmpty'),
                        trigger: 'blur',
                    },
                ],
                stopReason: [
                    {
                        required: true,
                        message: this.$t('taskPage.taskList.terminateReasonEmpty'),
                        trigger: 'blur',
                    },
                ],
            },
            statusAll: [],
            cols: [],
            selectionArray: [],
            map: {},
            UnitVal: [], // 申请单位,
            Unitoptions: [],
            dataSubjectOptions: [],
            deptList: [],
            exeProps: {
                children: 'children',
                label: 'label',
            },
            dataSubjectProps: {
                value: 'id',
                label: 'name',
                children: 'children',
            },

            deptProps: {
                value: 'deptId',
                label: 'deptName',
                children: 'children',
            },

            TypeVal: '', // 任务分类
            ItemVal: '', // 任务分类
            Typeoptions: [],
            Itemoptions: [],
            activeName: undefined,
            oldTaskStatus: null,
            checkAll: false,
            allLength: 0,
            selectDate: [],
            planDate: [],
            taskName: '',
            taskAddTime: '',
            taskNumber: '',
            taskPageList: [],
            showField: false,
            taskId: '',
            isSetting1: false,
            isSetting2: false,
            pageArray: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
                reset: false,
            },
            searchType: 1,
            mountTime: false,
            showTaskDialog: false,
            siteArray: [],
            ImplementWayArray: [],
            selectObj: {
                name: undefined,
                deptId: undefined,
                dataSubjectId: undefined,
                model: undefined,
            },
            exeTypeLabel: [],
            site: '',
            organlistId: '', // 机构子id
            newTaskData: [],
            selectType: 1,
            addTaskType: 1,
            // loading: null,
            saveTime: -1,
            searchData: {
                code: '',
                name: '',
                siteId: '',
                serviceId: '',
                mode: '',
                taskStatus: '',
                beginTime: '',
                endTime: '',
            },
        };
    },
    computed: {
        appCode() {
            // 取当前所属应用，优先从路由参数中取，如果没有再从localStorage中取
            let appCode = this.$route.query.appCode || localStorage.getItem('appCode') || '';
            // console.log('appCode',appCode)
            return appCode;
        },
    },
    mounted() {
        this.taskPageList = [];
        if (this.$refs.radio) {
            this.$refs.radio.$children.forEach((item) => {
                item.$refs.radio.removeAttribute('aria-hidden');
            });
        }
        this.getSelectDataOptions();
        this.getStatusCount();
        // this.initTable();
        this.getItemOptions();

        let { active, search } = this.$store.state.Common.PageBackObj;
        this.activeName = active || 99;
        // if (active && search.page) {
        //     console.log(active, search, '返回条件');
        //     this.activeName = active;
        //     this.selectObj = search;
        //     // this.exeTypeLabel = searchData.model;
        //     this.taskName = search.name;
        //     this.taskNumber = search.code;
        //     this.TypeVal = search.typeId;
        //     this.site = search.siteId;
        //     this.organlistId = search.organId;
        //     // this.ItemVal = search.itemId;
        //     // this.pageArray.reset = false;
        //     this.pageArray.currentPage = search.page;
        //     this.pageArray.pageSize = search.rows;
        //     this.getStatusCount({ ...search });
        //     this.screenTask({ ...search });
        //     if (search.endTime && search.beginTime) {
        //         this.selectDate = [
        //             search.beginTime.split(' ')[0],
        //             search.endTime.split(' ')[0],
        //         ];
        //         console.log(this.selectDate, '返回的日期');
        //     }
        //     // this.pageArray.reset = page.reset;
        //     // this.pageArray.totalResult = page.totalResult;
        // } else {
        //     this.activeName = 99;
        //     console.log(active, search, '返回条件1111');

        // }

        // this.getSiteArray();
        // this.getSysdidtvalue();
        this.getInitList();
    },
    methods: {
        async getSelectDataOptions() {
            await api.selectFindItemList().then((res) => {
                // 服务项
                this.dataSubjectOptions = res.data || [];
            });
        },
        taskHandle(el) {
            console.log(el, 'el');
            switch (el.eve) {
                case 'taskOver':
                    this.taskOver(el.data);
                    break;
                case 'ConfirmTask':
                    this.ConfirmTask(el.data);
                    break;
                case 'taskEnd':
                    this.taskEnd(el.data);
                    break;
                case 'taskStop':
                    this.taskStop(el.data);
                    break;

                default:
                    break;
            }
        },
        ConfirmTask(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'confirmTask';
            this.dialogTitle = this.$t('taskPage.taskList.confirmPassword');
            this.taskform.id = el.id;
        },
        taskOver(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'overTask';
            this.dialogTitle = this.$t('taskPage.taskList.completeUpload');
            this.taskform.id = el.id;
        },
        taskStop(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'endTask';
            this.dialogTitle = this.$t('taskPage.taskList.terminateTask');
            this.taskform.id = el.id;
        },
        taskEnd(el) {
            this.dialogVisible = true;
            this.dialogtaskType = 'compeleteTask';
            this.dialogTitle = this.$t('taskPage.taskList.endTask');
            this.taskform.id = el.id;
        },
        async passTask() {
            switch (this.dialogtaskType) {
                case 'confirmTask':
                    await api.startTask(this.taskform).then((res) => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.dialogtaskType = '';
                            this.dialogTitle = '';
                            this.$message.success(this.$t('taskPage.taskList.confirmTaskSuccess'));
                            this.resetdialog();
                            this.saveAddTask();
                            // 刷新数据
                        } else {
                            this.$message.error(`${res.msg}`);
                        }
                    });
                    break;
                case 'compeleteTask':
                    await api.compeleteTask(this.taskform).then((res) => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.dialogtaskType = '';
                            this.dialogTitle = '';
                            this.$message.success(this.$t('taskPage.taskList.endTaskSuccess'));
                            this.resetdialog();
                            this.saveAddTask();
                        } else {
                            this.$message.error(`${res.msg}`);
                        }
                    });
                    break;
                case 'endTask':
                    await api.endTask(this.taskform).then((res) => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.dialogtaskType = '';
                            this.dialogTitle = '';
                            this.$message.success(this.$t('taskPage.taskList.terminateTaskSuccess'));
                            this.resetdialog();
                            this.saveAddTask();
                        } else {
                            this.$message.error(`${res.msg}`);
                        }
                    });
                    break;
                case 'overTask':
                    await api.overTask(this.taskform).then((res) => {
                        if (res.code == 200) {
                            this.dialogVisible = false;
                            this.dialogtaskType = '';
                            this.dialogTitle = '';
                            this.$message.success(this.$t('taskPage.taskList.completeUploadSuccess'));
                            this.resetdialog();
                            this.saveAddTask();
                        } else {
                            this.$message.error(`${res.msg}`);
                        }
                    });
                    break;

                default:
                    break;
            }
        },
        resetdialog() {
            this.taskform = {};
        },
        taskClose() {
            this.dialogVisible = false;
        },
        subjectChange(val) {
            this.selectObj.dataSubjectId = val.id;
        },
        deptChange(val) {
            this.selectObj.deptId = val.deptId;
        },
        daychange(val) {
            console.log(val, '实际执行时间');
        },
        planchange(val) {
            console.log(val, '计划执行时间');
        },
        taskTypeChange() {
            this.pageArray.currentPage = 1;
        },

        async getInitList() {
            let res = await api.selectTaskInsti();
            if (res.data && res.data.length > 0) {
                this.deptList = handleTree(res.data, 'deptId');
            }
        },
        async getItemOptions() {
            await api.selectFindItemList().then((res) => {
                // 初始化专题服务
                console.log(res.data, '服务项');
                this.Itemoptions = res.data;
            });
        },
        addNewTask(data, T) {
            this.taskAddTime = T;
            this.taskId = '';
            this.addTaskType = data;
            this.showTaskDialog = true;
            console.log('新增任务');
        },
        UnitChange() {
            let k = this.UnitVal.length - 1;
            this.organlistId = this.UnitVal[k];
        },
        handleClick() {
            // this.pageArray.currentPage = 1;
            // this.selectObj.page = 1;
            // // this.pageArray.pageSize = 10;
            // this.pageArray.reset = true;
            // this.$store.commit("SET_PAGEOBJ", { active: this.activeName == 99 ? undefined : this.activeName, page: {} });
            // this.taskStatus = this.activeName;
            // this.oldTaskStatus = this.activeName === 99 ? "" : this.activeName.toString();
            // this.initTable();
        },
        saveAddTask(el) {
            this.saveTime = new Date().getTime();
            this.showTaskDialog = false;
            this.addTaskType = 1;
            this.taskId = '';
            this.initTable();
            this.getStatusCount();
        },
        addATask(el) {
            if (el) {
                this.showTaskDialog = false;
            } else {
                this.showTaskDialog = true;
            }
            this.initTable();
            this.getStatusCount();
        },
        showBg(type) {
            if (type === 2) {
                if (this.mountTime) {
                    this.mountTime = !this.mountTime;
                    this.showField = true;
                    this.isSetting2 = true;
                } else {
                    this.mountTime = !this.mountTime;
                    this.showField = false;
                    this.isSetting2 = false;
                }
            }
        },
        async getStatusCount(obj = {}) {
            console.log(obj, 'aaa');
            obj.appCode = this.appCode;
            let res = await api.getStatusCount(obj);
            if (res.data && res.data.length > 0) {
                // this.taskStatuslist = res.data;
                let count = 0;
                res.data.map((item) => {
                    if (item.taskStatus !== '4') {
                        count += item.count;
                    }
                });

                this.selectionArray = res.data;
                this.selectionArray.push({
                    count,
                    name: '全部状态',
                    status: '0',
                });
                console.log(this.selectionArray, 'count');
            }

            // api.findCount(val)
            //     .run()
            //     .then((res) => {
            //         this.selectionArray = res;
            //     });
        },
        getCountByStatus(sts) {
            if (this.selectionArray.length > 0) {
                let counObj;

                counObj = this.selectionArray.find((item) => item.status === sts);

                return counObj ? counObj.count : 0;
            } else {
                return 0;
            }
        },
        async initTable() {
            let select1 = {
                ...this.selectObj,
                taskStatus: this.activeName === 99 ? undefined : `${this.activeName}`,
                pageNum: this.pageArray.currentPage,
                pageSize: this.pageArray.pageSize,
                appCode: this.appCode,
            };
            console.log(select1, 'search');
            let res = await api.getPageList(select1);
            console.log(res, '数据');
            this.pageArray.totalResult = res.total;

            if (res.rows) {
                this.taskPageList = res.rows;
            }
        },

        resetTask() {
            // this.pageArray.reset = true;
            this.pageArray.currentPage = 1;
            this.pageArray.pageSize = 10;
            this.taskNumber = '';
            this.taskName = '';
            this.site = '';
            this.AssociatedTasks = '';
            this.exeTypeLabel = [];
            this.statusAll = [];
            this.selectDate = [];
            this.planDate = [];
            this.searchType = 1;
            this.UnitVal = [];
            this.TypeVal = '';
            this.ItemVal = '';
            this.organlistId = '';
            this.searchData = {
                code: '',
                name: '',
                siteId: '',
                serviceId: '',
                mode: '',
                taskStatus: '',
                beginTime: '',
                endTime: '',
            };
            this.selectObj = {};
            this.getStatusCount();
            this.initTable();
        },
        screenTask() {
            console.log(this.UnitVal, 'this.activeName');
            this.searchType = 2;
            const params = {
                beginTime: '',
                endTime: '',
            };
            this.selectObj = {
                ...this.selectObj,
                pageNum: this.pageArray.currentPage,
                pageSize: this.pageArray.pageSize,
                taskStatus: this.activeName === 99 ? undefined : `${this.activeName}`,
                appCode: this.appCode,
            };
            // console.log(this.selectObj, this.selectDate, '查询条件');
            //   params['endTime']= this.selectDate[1] || '';
            //    params['startTime']= this.selectDate[0] || '';
            let search = addDateRange(this.selectObj, this.selectDate);
            search = addDateRange(search, this.planDate, 'plan');

            // console.log(search, 'aaa');
            api.getPageList(search).then((res) => {
                console.log(res, '表格数据');
                this.taskPageList = res.rows || [];
                this.pageArray.totalResult = res.total;
            });
            this.getStatusCount(search);

            if (this.type === 3) {
                // 日历模式查询功能
                this.searchData = {
                    code: this.taskNumber,
                    name: this.taskName,
                    siteId: this.site,
                    serviceId: this.AssociatedTasks,
                    // mode: this.exeTypeLabel,
                    model: this.searchData.model,
                    taskStatus: this.statusAll.join(','),
                };
            }
        },
        showForm(el) {
            this.showTaskDialog = !this.showTaskDialog;
            if (el.edit) {
                // 编辑任务
                this.taskId = el.edit.id;
                this.addTaskType = 2;
            }
        },
        SavePage() {
            console.log(this.pageArray, this.selectObj, '页面数据++++++++');
            this.$store.commit('SET_PAGEOBJ', {
                active: this.activeName,
                search: { ...this.selectObj, ...this.pageArray, ...this.searchData },
            });
        },
        SaveCalendPage(val) {
            this.$store.commit('SET_PAGEOBJ', { active: this.activeName, calendarDate: val });
        },
        handleStatusChange(val) {
            if (this.statusAll.length < Object.keys(this.selectionArray).length) {
                this.checkAll = false;
            } else if (this.statusAll.length === Object.keys(this.selectionArray).length) {
                this.checkAll = true;
            }
        },
        fetchData(obj) {
            this.pageArray.reset = false;
            this.pageArray.currentPage = obj.page;
            this.pageArray.pageSize = obj.rows;
            if (this.searchType === 1) {
                this.initTable();
            }
            if (this.searchType === 2) {
                this.screenTask();
            }
        },
        // 获取站点
        getSiteArray() {
            api.getSiteList()
                .run()
                .then((res) => {
                    this.siteArray = res;
                });
        },
        getSysdidtvalue() {
            let obj = {
                ident: 'dict_task_model',
            };
            api.getSysDict(obj)
                .run()
                .then((res) => {
                    this.ImplementWayArray = res;
                });
        },
    },
    watch: {
        type: {
            handler(val) {
                if (this.$refs.radio && val == 2) {
                    this.$refs.radio.$children.forEach((item) => {
                        item.$refs.radio.removeAttribute('aria-hidden');
                    });
                }
            },
        },
        activeName: {
            handler(newVal) {
                if (newVal) {
                    this.taskStatus = this.activeName === 99 ? '' : `${this.activeName}`;
                    // this.pageArray.totalResult = this.getCountByStatus(newVal + "");
                    this.$store.commit('SET_PAGEOBJ', {
                        active: this.activeName == 99 ? undefined : this.activeName,
                        page: {},
                    });

                    // this.taskPageList = [];
                    // this.screenTask();
                    this.initTable();
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
// 滚动条样式
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: rgba(239, 239, 239, 0.1);
}

::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
}

::v-deep .el-tag.el-tag--info .el-tag__close {
    display: none;
}

::v-deep .el-checkbox__inner {
    border: 1px solid;
}

::v-deep .el-icon-caret-right:before {
    display: none;
}

::v-deep .el-checkbox__inner::after {
    // display: none;
    border: 1px solid #000;
    border-left: 0;
    border-top: 0;
}

::v-deep .el-tree-node.is-expanded.is-checked > .el-tree-node__content > .el-tree-node__label {
    color: #49f0fd;
}

::v-deep .el-tree-node.is-checked > .el-tree-node__label {
    // background-color: #ccc !important;
    color: #49f0fd;
}

::v-deep .el-tree {
    background-color: #071150;
    color: #fff;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #49f0fd;
    color: #49f0fd;
    border: 1px solid;
}

::v-deep .el-checkbox > .el-checkbox__input.is-indeterminate > .el-checkbox__inner::before {
    background-color: #000;
}

::v-deep .el-checkbox > .el-checkbox__input.is-indeterminate > .el-checkbox__inner {
    background-color: #49f0fd;
}
</style>
<style lang="scss">
@import '@/global/common.scss';

.selectType {
    height: 34px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;

    img {
        vertical-align: middle;
    }
}

.tasklist {
    .el-dialog {
        width: 500px;
        height: 300px;
        background: #071150;
        box-shadow: inset 0px 0px 10px 0px #49f0fd;
        opacity: 1;
        border: 1px solid #49f0fd;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .el-dialog__title {
            color: #49f0fd;
        }

        .dialog__footer {
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);

            .el-button {
                width: 100px;
                height: 30px;
            }

            .save {
                color: black;
                background-color: #49f0fd;
                border: 1px solid #49f0fd;
            }

            .cancel {
                background: rgba(73, 240, 253, 0.2);
                border-radius: 2px 2px 2px 2px;
                opacity: 1;
                border: 1px solid #49f0fd;
                color: #49f0fd;
            }
        }

        .fix-close {
            position: absolute;
            top: -20px;
            right: -20px;
            cursor: pointer;
        }
    }

    .el-form-item__label {
        color: #fff;
    }

    .el-input__inner {
        background-color: #071150 !important;
        border: 1px solid rgba(135, 161, 216, 0.7) !important;
        color: #fff !important;
    }
}

.c-taskpage-taskList {
    box-sizing: border-box;
    width: calc(100% - 8px);
    height: 118px;
    line-height: 118px;
    margin: 8px 4px;
    background: #071150;
    border-radius: 3px 3px 3px 3px;
    opacity: 1;
    border-top: 6px solid transparent;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 6px solid transparent;
    border-image: url(../imgs/bg_wrap.png) 10 10;
    overflow-x: auto;

    .el-checkbox__inner::after {
        border: 1px solid #000;
        border-top: 0;
        border-left: 0;
    }

    .task-status {
        // padding-top: 20px;
        margin-left: 20px;
        // margin-bottom: 4px;
        height: 52px;
        line-height: 52px;
        vertical-align: middle;
        white-space: nowrap;

        .taskSelectLine {
            display: inline-block;
            height: 54px;
            line-height: 54px;

            .el-tabs__active-bar {
                display: none;
            }

            .taskSelect-active {
                color: green;
            }

            .el-tabs__item.is-active {
                color: #f4a460 !important;
            }
        }

        .el-checkbox__label {
            color: #fff;
        }

        .el-checkbox__inner {
            border-color: #49f0fd;
            background-color: #071150;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #49f0fd !important;
        }

        // display: flex;
        color: #fff;

        .task-status-first {
            display: inline-block;
            width: 56px;
            height: 54px;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            line-height: 54px;
            //   padding: 8px 8px 8px 0;
            color: #fff;
        }

        .el-tabs__item {
            color: #fff;
        }

        .el-tabs__nav-wrap::after {
            display: none;
        }

        .allStatus {
            position: relative;
            left: 8px;
        }

        input[type='checkbox']::after {
            position: absolute;
            top: 0;
            //修改默认背景色
            background-color: #fff;
            border: 1px solid #000;
            //修改默认对勾颜色
            // color: #28b28b;
            width: 16px;
            height: 16px;
            display: inline-block;
            visibility: visible;
            text-align: center;
            content: ' ';
        }

        .status-checkbox {
            height: 24px;
            line-height: 35px;
            display: inline-block;
            position: relative;
            left: 24px;
            color: #fff !important;

            .el-radio {
                color: #fff;

                .el-radio__input.is-checked + .el-radio__label {
                    color: #fff;
                }

                .el-radio__input.is-checked .el-radio__inner {
                    border-color: #49f0fd;
                    background: #49f0fd;
                }
            }
        }
    }

    .task-find {
        position: relative;
        margin-left: 20px;
        display: flex;
        color: #fff;
        white-space: nowrap;

        .el-input__inner {
            background-color: #112d7b !important;
            border: 1px solid #1a47a4 !important;
            box-sizing: border-box;
            color: #fff;
            display: inline-block;
            font-size: inherit;
            height: 40px;
            line-height: 40px;
            outline: 0;
            // padding: 0 15px;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            width: 100%;
        }

        .task-name {
            // width: 11.7vw;
            height: 40px;
            line-height: 40px;
            display: flex;
            color: #fff;

            .el-select-dropdown {
                background: rgba(7, 17, 80, 0.75);
                box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
                opacity: 1;
                border: 1px solid #49f0fd;
            }

            .el-select-dropdown__item.hover,
            .el-select-dropdown__item:hover {
                background: linear-gradient(
                    270deg,
                    rgba(73, 240, 253, 0) 0%,
                    rgba(73, 240, 253, 0.4) 32%,
                    rgba(73, 240, 253, 0.4) 66%,
                    rgba(73, 240, 253, 0) 100%
                );
                border-radius: 0px 0px 0px 0px;
                opacity: 1;
                color: #fff;
            }

            .el-popper[x-placement^='bottom'] .popper__arrow {
                left: 50% !important;
                transform: translateX(-50%) !important;
            }

            .el-select-dropdown__item {
                text-align: center;
            }

            .task-name-first {
                position: relative;
                display: inline-block;
                // min-width: 56px;
                // height: 24px;
                font-size: 14px;
                line-height: 22px;
                margin-right: 5px;
                padding: 8px 8px 8px 0;
                color: #fff;
            }

            .el-input {
                width: 150px;
            }
        }

        .task-name:not(:first-child) {
            margin-left: 0.8vw;
        }

        .task-name-date {
            height: 40px;
            line-height: 40px;
            margin-left: 15px;
            display: flex;
            color: #fff;
            position: relative;
            display: flex;

            .task-name-first {
                line-height: 24px;
                padding: 8px 8px 8px 0;
                color: #fff;
                font-size: 14px;
            }

            .not-time {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
            }

            .el-range-editor--small .el-range__icon {
                line-height: 40px;
                position: absolute;
                // left: 0.6vw;
                left: 10px;
                top: 2px;
                display: none;
            }

            .el-range-editor--small .el-range__close-icon {
                position: absolute;
                right: 0;
                top: 8px;
            }

            .el-range-editor--small .el-range-separator {
                color: #fff;
                height: 35px;
                line-height: 35px;
                position: relative;
                top: -5px;
            }

            .el-range-input {
                color: #fff;
                font-size: 12px;
                background-color: #112d7b !important;
                height: 2.5vh;
            }

            .el-range-editor--small .el-range-input {
                font-size: 12px;
                background-color: #112d7b !important;
                height: 35px;
                line-height: 35px;
                position: relative;
                top: -5px;
            }

            .el-input__icon:after {
                width: 15px;
                height: 15px;
                color: #fff;
            }

            .date-picker-icon {
                color: #fff;
            }
        }

        .el-date-editor--daterange.el-input__inner {
            width: 200px !important;
        }

        .task-refresh-list {
            width: 82px;
            min-width: 82px;
            height: 40px;
            line-height: 40px;
            margin-left: 0.8vw;
            text-align: center;
            color: #49f0fd;
            background: rgba(73, 240, 253, 0.2);
            box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
            border-radius: 2px;
            opacity: 1;
            border: 1px solid rgba(73, 240, 253, 0.4);
        }

        .task-search-other {
            width: 82px;

            height: 40px;
            line-height: 40px;
            margin-left: 0.8vw;
            text-align: center;
            color: #fff;
            background: #2e7df8;
            box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
            border-radius: 2px;
            opacity: 1;
            // .tab-title{
            //     text-align: center;
            //     display: inline-block;
            //     width: 60px;
            // }
        }

        .task-search-list {
            width: 82px;
            min-width: 82px;
            height: 40px;
            margin-left: 0.8vw;
            line-height: 40px;
            color: #071150;
            text-align: center;
            background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
            border-radius: 2px;
            opacity: 1;
            border: 1px solid rgba(73, 240, 253, 0.4);
            // .tab-title{
            //     text-align: center;
            //     display: inline-block;
            //     width: 60px;
            // }
        }

        .task-refresh-other {
            width: 82px !important;
            height: 40px;
            margin-left: 0.8vw;
            line-height: 40px;
            color: #fff;
            text-align: center;
            background: #112d7b;
            border-radius: 2px;
            opacity: 1;
        }
    }
}

.newTask {
    height: calc(100% - 118px - 20px - 10px);
    margin: 8px 4px 0 4px;
    background: #071150;
    border-radius: 2px;
    border-top: 6px solid transparent;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 6px solid transparent;
    border-image: url(../imgs/bg_wrap.png) 10 10;

    .addNewTask-line {
        position: relative;
        width: 100%;
        height: 52px;

        .addTask-top {
            float: right;
            padding-right: 1.6vw;
            display: flex;
            margin-top: 10.8px;
            margin-bottom: 8px;
        }

        .addNewTask {
            display: inline-block;
            width: 110px;
            height: 36px;
            margin-left: 8px;
            line-height: 36px;
            color: #071150;
            text-align: center;
            background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
            border-radius: 2px;
            opacity: 1;
            border: 1px solid rgba(73, 240, 253, 0.4);
            cursor: pointer;
        }

        .newTask-ul {
            display: inline-block;
            margin-left: 16px;
            width: 38px;
            color: #49f0fd;
            height: 36px;
            line-height: 36px;
            text-align: center;
            background: rgba(73, 240, 253, 0.2);
            box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            border: 1px solid rgba(73, 240, 253, 0.4);
            cursor: pointer;
        }

        .isSetting {
            display: inline-block;
            margin-left: 16px;
            width: 38px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            background: rgba(73, 240, 253, 0.4) !important;
            box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            border: 1px solid rgba(73, 240, 253, 0.4);
            cursor: pointer;
        }
    }

    .TaskTable2 {
        width: 100%;
        height: calc(100% - 92px);
        overflow: hidden;

        .table {
            height: 100%;
            background-color: #071150 !important;
        }
    }

    .pagepagetion {
        background-color: #071150 !important;
        color: #fff;
        height: 3.1vh;
        line-height: 3.1vh;
        margin-top: 2px;
    }

    .el-scrollbar__wrap {
        margin-bottom: 0 !important;
    }
}

.taskmain {
    height: calc(100% - 20px - 10px);
    margin: 0 4px;
    box-sizing: border-box;
    position: relative;
    top: 8px;

    .task-calendar .el-calendar-table {
        height: 100%;
    }

    .el-calendar {
        height: 100%;

        .el-calendar__body {
            height: calc(100% - 60px);
            overflow-y: auto;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;

            /* IE10+ */
            &::-webkit-scrollbar {
                width: 5px;
                /*滚动条宽度*/
                height: 5px;
                /*滚动条高度*/
                background-color: transparent;
                // display: none; /* ChromeSafari */
            }

            &::-webkit-scrollbar-thumb {
                // box-shadow: 0px 1px 3px #00a0e9 inset; /*滚动条的内阴影*/
                border-radius: 10px;
                /*滚动条的圆角*/
                background-color: rgba(144, 147, 153, 0.3);
                /*滚动条的背景颜色*/
            }
        }
    }
}
</style>
